import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

const TIMEZONE = 'Asia/Hong_Kong'; // UTC+8 timezone

// TODO: will replace all checkInvalidDate with this isValidDate function.
export const isValidDate = (value: any): boolean => {
  return value !== null && value !== undefined && value !== '';
};

export const convertString2Date = (
  timeString: string | undefined,
  defaultTime?: Date,
): Date | undefined => {
  return isValidDate(timeString) ? new Date(timeString as string) : defaultTime;
};

export const formatDateString = (
  initialDate: Date | string | null | undefined,
  localTime: boolean = true, // TODO: will finally set default to false. To true for compatibility.
): string | undefined => {
  if (isValidDate(initialDate)) {
    if (localTime) {
      return dayjs(initialDate).format('DD/MM/YYYY');
    } else {
      return dayjs(initialDate).tz(TIMEZONE).format('DD/MM/YYYY');
    }
  } else {
    return undefined;
  }
};

export const formatDateStringMon = (
  initialDate: Date | string | null | undefined,
  localTime: boolean = true, // TODO: will finally set default to false. To true for compatibility.
): string | undefined => {
  if (isValidDate(initialDate)) {
    if (localTime) {
      return dayjs(initialDate).format('DD-MMM-YYYY');
    } else {
      return dayjs(initialDate).tz(TIMEZONE).format('DD-MMM-YYYY');
    }
  } else {
    return undefined;
  }
};

export const formatDateStringAccurate = (
  initialDate: Date | string | null | undefined,
): string | undefined => {
  const date = initialDate ?? '';
  if (date !== '') {
    return dayjs(initialDate).format('DD-MMM-YYYY HH:mm:ss');
  } else {
    return undefined;
  }
};

export const formatFileNameDateString = (
  initialDate: Date | string | null | undefined,
): string | undefined => {
  const date = initialDate ?? '';
  if (date !== '') {
    return dayjs(initialDate).format('DD/MM/YYYY_HH-mm-ss');
  } else {
    return undefined;
  }
};

export const formatTimeString = (
  initialDate: Date | string | null | undefined,
): string | undefined => {
  const date = initialDate ?? '';
  if (date !== '') {
    return dayjs(initialDate).format('HH:mm:ss');
  } else {
    return undefined;
  }
};

export const isCurrentTimeInPeriod = (
  startTime: Date | undefined,
  endTime: Date | undefined,
): boolean => {
  if (!startTime && !endTime) {
    return false;
  }
  // Swap start and end if start is greater than end
  if (startTime && endTime && startTime > endTime) {
    [startTime, endTime] = [endTime, startTime];
  }
  const now = new Date();
  const isStart = !startTime || now > startTime;
  const isEnd = endTime ? now > endTime : false;
  const inPeriod = isStart && !isEnd;
  return inPeriod;
};
